import { createAsyncThunk } from '@reduxjs/toolkit';
import { RouteParamsType } from '../../types/utils/router-params.type';
import axios from 'axios';
import { rejectWithApiError } from '../../utils/api';
import { RootReducerState } from '../../redux/Reducers';
import { PaginationType } from '../../types/utils/pagination.type';

export const getAlarmsList = createAsyncThunk<PaginationType<unknown>, RouteParamsType, { state: RootReducerState }>(
  'alarms/getAlarmsList',
  async (params, thunkAPI) => {
    try {
      const queryString = Object.keys(params)
        .map(key => key + '=' + params[key])
        .join('&');

      const response = await axios.get<PaginationType<unknown>>(
        `https://contact-id.potsportal.com/${queryString ? `?${queryString}` : ''}`
      );
      return response.data;
    } catch (error) {
      return rejectWithApiError({ thunkAPI, error, fallback: 'Error during fetching Alarms list!' });
    }
  }
);
